import getFileURL from '../actions/getFileURL';

export const handleDownload = async (
    filePath: string,
    isAdmin = false,
    openInNewTab = true
) => {
    const url = await getFileURL(filePath, isAdmin);

    if (url) {
        if (openInNewTab) {
            window.open(url, '_blank');
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.download = filePath.split('/').pop() || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
